import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button/index";
import moment from "moment";
const currentDate = moment().format("YYYY-MM-DD");

const addInviteesButton = ({
  assessment_status__status_name,
  id,
  user_assessment__id,
  user_assessment__expiry_date,
  respondent_completed_count,
  batch__min_respondent,
  is_submited,
  user_assessment__instrument__id,
  respondent__id,
  user_assessment__instrument__is_multi_rater,
  organisation,
  seller,
}) => {
  if (currentDate > user_assessment__expiry_date) {
    return <Button type="disabled report"> Expired </Button>;
  } else if (
    respondent_completed_count < batch__min_respondent &&
    assessment_status__status_name === "Completed"
  ) {
    return (
      <Link
        to={{
          pathname: `/new/app/invitations/${id}`,
        }}
      >
        <Button type="start"> Invite Respondants </Button>
      </Link>
    );
  } else if (assessment_status__status_name === "Yet to start") {
    return (
      <Link
        to={{
          pathname: `/new/app/welcome/${user_assessment__instrument__id}/${user_assessment__id}/${organisation}/${seller}/${respondent__id}/${user_assessment__instrument__is_multi_rater}/${respondent_completed_count}/invitations`,
        }}
      >
        <Button type="start" style={{ textTransform:'uppercase'}}> Start </Button>
      </Link>
    );
  } else if (assessment_status__status_name === "In progress") {
    return (
      <Link
        to={{
          pathname: `/new/app/questionnaire/${user_assessment__instrument__id}/${user_assessment__id}/${organisation}/${seller}/${respondent__id}/${user_assessment__instrument__is_multi_rater}/${respondent_completed_count}/invitations`,
        }}
      >
        <Button type="resume">Resume</Button>
      </Link>
    );
  } else if (
    respondent_completed_count === batch__min_respondent &&
    is_submited === false
  ) {
    return (
      <Link
        to={{
          pathname: `/new/app/invitations/${id}`,
        }}
      >
        <Button type="start"> Ready TO SUBMIT </Button>
      </Link>
    );
  } else if (assessment_status__status_name === "Report in review") {
    return <p style={{ opacity: 0.5 }}>REPORT SUBMITTED</p>;
  } else if (assessment_status__status_name === "Completed") {
    return <p style={{ opacity: 0.5 }}>REPORT SUBMITTED</p>;
  } else return null;
};

export { addInviteesButton };



// WEBPACK FOOTER //
// ./src/new/Utils/addinviteesButton.jsx